import Vue from 'vue'
import i18n from '../../plugins/i18n'

const state = {
  active_language: i18n.GetActiveLanguage(),
  selected_language: localStorage.getItem('epp_language')
};

const getters = {

  getActiveLanguage(state) {
    return state.active_language
  },

  getSelectedLanguage(state) {
    return state.selected_language
  }
};

const mutations = {
  setActiveLanguage(state, langCode) {
    i18n.SetActiveLanguage(langCode)
    Vue.set(state, 'active_language', langCode)
    Vue.set(state, 'selected_language', langCode)
    localStorage.setItem('epp_language', langCode)
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/language.js